<template>
  <div class="wheel2">
    <div style="position: relative;width: 41px;">
      <div class="wheel2_left" @click="prev()"></div>
    </div>
    <div class="wheel2_content">
      <div class="swiper wheel_PV">
        <div class="swiper-wrapper">
          <div class="swiper-slide wheel2_center" v-for="(item,index) in data" :key="index">
            <div class="wheel2_img">
              <img :src="imgPath+item.thumbnail" alt @click="newsDetail(item.id)"/>
            </div>
            <div class="wheel2_wenzi">{{ item.news_subject }}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative;width: 41px;">
      <div class="wheel2_right" @click="next()"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import {GetPhotoVideosList} from "@/api/admin/common.js";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      data: [],
      slidesPerView: 4,
      paging: {
        limit: 6,
        page: 1
      },
      imgPath: window.apiObj.apiUrl
    };
  },
  computed: {
    ...mapGetters(["screenWidth"])
  },
  created() {
    this.getList();
    this.getScreenWidth(this.screenWidth);
  },
  watch: {
    screenWidth(val) {
      this.getScreenWidth(val);
    }
  },
  methods: {
    getScreenWidth(width) {
      this.creSwiper();
      if (width < 768) {
        this.slidesPerView = 2;
      } else {
        this.slidesPerView = 4;
      }
    },
    getList() {
      //精彩图片视频列表
      GetPhotoVideosList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    },
    prev() {
      this.data.unshift(this.data.pop());
    },
    next() {
      this.data.push(this.data.shift());
    },
    creSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper(".wheel_PV", {
          slidesPerView: this.slidesPerView,
          spaceBetween: 20
        });
      });
    },
    newsDetail(newsId) {
      this.$router.push({
        path: "/news/newsDetails",
        query: {id: newsId}
      })
    },
  }
};
</script>
<style lang="less" scoped>
.wheel2 {
  display: flex;
  justify-content: space-between;

  .wheel2_left {
    width: 40px;
    height: 70px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    margin-top: -35px;
    background-image: url(/image/index/icon-slides.png);
    background-size: cover;
    background-position: left;
    transform: translateY(-50%);
  }

  .wheel2_right {
    width: 40px;
    height: 70px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    margin-top: -35px;
    background-image: url(/image/index/icon-slides.png);
    background-size: cover;
    background-position: -45px 0px;
    transform: translateY(-50%);
  }

  .wheel2_content {
    width: 94%;

    .wheel2_center {
      background: #ffffff;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
      border-radius: 0px 0px 4px 4px;
      min-height: 268px;
      width: 23.7%;
      margin-right: 20px;
      cursor: pointer;

      .wheel2_img {
        img {
          width: 100%;
          height: 200px;
        }
      }

      .wheel2_wenzi {
        padding: 10px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .wheel2 .wheel2_content {
    width: 100% !important;

    .wheel2_center {
      width: 24% !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .wheel2 .wheel2_content {
    width: 78% !important;

    .wheel2_center {
      width: 100% !important;
    }
  }
}
</style>
